import React, { useEffect, useState } from 'react';
import { Modal, Input, Form, Flex } from 'antd';
import styles from './ForgotPasswordModal.module.scss';
import { ReactComponent as CrossIcon } from '../../../../assets/images/global-icons/cross_ic.svg';
import CustomButton from '../../CustomButton/CustomButton';
import { CheckEmailModal } from '../../../LeftMenu/components/CheckEmailModal/CheckEmailModal'; 
import { useForgotPasswordMutation } from '../../../../redux/API/userSlice';

interface ForgotPasswordModalProps {
  open: boolean;
  onClose: () => void;
  onComplete: () => void;
  email: string;
}

const ForgotPasswordModal: React.FC<ForgotPasswordModalProps> = ({ open, onClose, email, onComplete }) => {
  const [searchValue, setSearchValue] = useState('');
  const [mode, setMode] = useState<'form' | 'confirmation'>('form');
  const [forgotPassword] = useForgotPasswordMutation();

  const handleConfirmationClose = () => {
    if (mode === 'confirmation') {
      onComplete();
    }
    setMode('form');
    onClose();
  };
  

  useEffect(() => {
    setSearchValue(email);
    setMode('form');
  }, [email, open]);

  const handleNextClick = async () => {
    try {
      await forgotPassword({ email: searchValue }).unwrap();
      setMode('confirmation');
    } catch (error) {
      console.error('Error sending forgot password email:', error);
    }
  };


  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      maskClosable={true}
      onCancel={handleConfirmationClose}
      centered
      width={745}
      className={styles.modal}
    >
      <Flex justify="space-between" align="center" className={styles.modal__header}>
        <h3>Forgot password</h3>
        <CrossIcon color={'#000000'} onClick={handleConfirmationClose} />
      </Flex>

      <Flex vertical align="center" className={styles.modal__body}>
        {mode === 'form' ? (
          <>
            <h2 className={styles.modal__title}>Restore password</h2>
            <p className={styles.modal__subtitle}>
              Enter the email address associated with your account, and we’ll send you a link to reset your password.
            </p>

            <Form className={styles.modal__body__form} layout="vertical">
              <Form.Item className={styles.modal__body__form__formItem} label="E-mail">
                <Input
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder="Email"
                  className={styles.modal__body__form__formItem__input}
                />
              </Form.Item>

              <Form.Item className={styles.modal__body__form__customButton}>
                <CustomButton
                  onClick={handleNextClick}
                  text="Next"
                  disable={searchValue.trim() === ''}
                  htmlType="submit"
                />
              </Form.Item>
            </Form>
          </>
        ) : (
          <CheckEmailModal
            text="We've sent an email with reset password instruction. If haven't received an email within few minutes then check your spam folder."
            onResend={handleNextClick}
          />
        )}
      </Flex>
    </Modal>
  );
};
export default ForgotPasswordModal;